import { defineStore } from 'pinia'
import CommentsService from "@/services/comment.service.ts";
export const useCommentStore = defineStore('comment', {
    state: () => {
        return {
            comments: [],
            comment: {}
        }
    },
    persist: true,
    actions: {
        async createComment(url, params) {
            try {
                const comment = await CommentsService.createComment(url, params)
                this.comment = comment.data.data
            } catch (e) {
                return null
            }
        },
    }
})
